import classes from './Overlay.module.scss';

interface OverlayProps {
  showOverlay: boolean;
}

export const Overlay: React.FC<OverlayProps> = ({ showOverlay }) => {
  return (
    <div
      className={classes['overlay']}
      style={{ display: showOverlay ? 'block' : 'none' }}
    />
  );
};
